module.exports = "/images/cover-2.jpg";